import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "️-react-wordcloud"
    }}>{`☁️ react-wordcloud`}</h1>
    <p>{`Simple React + D3 wordcloud component with powerful features. Uses the `}
      <a {...{
        "href": "https://github.com/jasondavies/d3-cloud",
        "parentName": "p"
      }}><inlineCode {...{
          "parentName": "a"
        }}>{`d3-cloud`}</inlineCode></a>
      {` layout.`}</p>
    <p>{`<img alt="image" src={require(".//public/wordcloud.png")} />`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code {...{
        "className": "language-sh",
        "parentName": "pre"
      }}>{`npm install react-wordcloud
`}</code></pre>
    <p>{`Note that `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`react-wordcloud`}</inlineCode>
      {` requires `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`react^16.13.0`}</inlineCode>
      {` as a peer dependency.`}</p>
    <h2 {...{
      "id": "use"
    }}>{`Use`}</h2>
    <h3 {...{
      "id": "simple"
    }}>{`Simple`}</h3>
    <pre><code {...{
        "className": "language-js",
        "parentName": "pre"
      }}>{`import React from 'react';
import ReactWordcloud from 'react-wordcloud';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

const words = [
  {
    text: 'told',
    value: 64,
  },
  {
    text: 'mistake',
    value: 11,
  },
  {
    text: 'thought',
    value: 16,
  },
  {
    text: 'bad',
    value: 17,
  },
]

function SimpleWordcloud() {
  return <ReactWordcloud words={words} />
}
`}</code></pre>
    <p>{`By default, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`ReactWordcloud`}</inlineCode>
      {` is configured with animated tooltips enabled and requires CSS for styling. Tippy provides base styling in the resources above or you can create your own.`}</p>
    <h3 {...{
      "id": "kitchen-sink"
    }}>{`Kitchen Sink`}</h3>
    <p>{`An example showing various features (callbacks, options, size).`}</p>
    <pre><code {...{
        "className": "language-js",
        "parentName": "pre"
      }}>{`const callbacks = {
  getWordColor: word => word.value > 50 ? "blue" : "red",
  onWordClick: console.log,
  onWordMouseOver: console.log,
  getWordTooltip: word => \`\${word.text} (\${word.value}) [\${word.value > 50 ? "good" : "bad"}]\`,
}
const options = {
  rotations: 2,
  rotationAngles: [-90, 0],
};
const size = [600, 400];
const words = [...];

function MyWordcloud() {
  return (
    <ReactWordcloud
      callbacks={callbacks}
      options={options}
      size={size}
      words={words}
    />
  );
}
`}</code></pre>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`View all documented examples and gallery of `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`react-wordcloud`}</inlineCode>
      {` applications at `}
      <a {...{
        "href": "https://react-wordcloud.netlify.com/",
        "parentName": "p"
      }}>{`https://react-wordcloud.netlify.com/`}</a>
      {`.`}</p>
    <p>{`You can also run the examples locally:`}</p>
    <pre><code {...{
        "className": "language-sh",
        "parentName": "pre"
      }}>{`git clone git@github.com:chrisrzhou/react-wordcloud

cd react-wordcloud
npm install && npm run docs
`}</code></pre>
    <h3 {...{
      "id": "no-props"
    }}>{`No props`}</h3>
    <p><a {...{
        "href": "https://codesandbox.io/s/bgov9",
        "parentName": "p"
      }}>{`<img alt="Edit react-wordcloud-simple" src="https://codesandbox.io/static/img/play-codesandbox.svg" />`}</a></p>
    <h3 {...{
      "id": "responsive"
    }}>{`Responsive`}</h3>
    <p><a {...{
        "href": "https://codesandbox.io/s/55sb8",
        "parentName": "p"
      }}>{`<img alt="Edit react-wordcloud-simple" src="https://codesandbox.io/static/img/play-codesandbox.svg" />`}</a></p>
    <h3 {...{
      "id": "configurable-options"
    }}>{`Configurable Options`}</h3>
    <p><a {...{
        "href": "https://codesandbox.io/s/fnk8w",
        "parentName": "p"
      }}>{`<img alt="Edit react-wordcloud-interactive" src="https://codesandbox.io/static/img/play-codesandbox.svg" />`}</a></p>
    <h3 {...{
      "id": "callbacks"
    }}>{`Callbacks`}</h3>
    <p><a {...{
        "href": "https://codesandbox.io/s/4lecp",
        "parentName": "p"
      }}>{`<img alt="Edit react-wordcloud-interactive" src="https://codesandbox.io/static/img/play-codesandbox.svg" />`}</a></p>
    <h2 {...{
      "id": "wordcloud-generator"
    }}>{`Wordcloud Generator`}</h2>
    <p>{`Create wordclouds using this wordcloud generator: `}
      <a {...{
        "href": "https://wordcloud-generator.netlify.com/",
        "parentName": "p"
      }}>{`https://wordcloud-generator.netlify.com/`}</a></p>
    <p>{`Features supported:`}</p>
    <ul>

      <li {...{
        "parentName": "ul"
      }}>{`Edit and Upload text inputs`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Various NLP features (stopwords, ngrams)`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Wordcloud configurations`}</li>


      <li {...{
        "parentName": "ul"
      }}>{`Export/save/share wordclouds`}</li>

    </ul>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`The code is written in `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`typescript`}</inlineCode>
      {`, linted with `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`xo`}</inlineCode>
      {`, and built with `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`microbundle`}</inlineCode>
      {`. Examples and documentations are built with `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`docz`}</inlineCode>
      {`.`}</p>
    <p>{`Feel free to contribute by submitting a pull request.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      